import { createApiAction } from '@app/packages/api/utils'
import type { ApiParent, ApiSitter } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'
import { v2Path } from '@app/packages/api/v2/utils'

type FavoritesPageMeta = { total: number; total_pages: number; current_page: number }

export const getFavorites = (page: number, per_page: number = 10) =>
  createApiAction('getFavorites', dispatch =>
    dispatch<ApiDataResponse<(ApiSitter | ApiParent)[]> & { meta: FavoritesPageMeta }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/favorites', { page, per_page }),
    })
  )

export const postFavorites = (user_id: string) =>
  createApiAction('postFavorites', dispatch =>
    dispatch<ApiDataResponse<ApiSitter | ApiParent>>({ method: 'POST', endpoint: '/api/v2/favorites', body: JSON.stringify({ user_id }) })
  )

export const deleteFavorites = (user_id: string) =>
  createApiAction('deleteFavorites', dispatch =>
    dispatch<ApiDataResponse<ApiSitter | ApiParent>>({ method: 'DELETE', endpoint: v2Path('/api/v2/favorites', { user_id }) })
  )
